import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import './styles.scss';

const ButtonCrudAction = ({ classNames = [], ...props }) => (
    <Button {...props} classNames={['custom-btn-crud-action', ...classNames]} />
);

ButtonCrudAction.propTypes = {
    classNames: PropTypes.arrayOf(PropTypes.string),
    onClick: PropTypes.func,
};

export default ButtonCrudAction;
